import React, { Component } from "react";
import { photothequeApiUpsellProvider } from "./../../lib/api/providers";
import { Icon } from "antd";
import PropTypes from "prop-types";
import { setFlagToMedia } from "./../../redux/actions/photothequeActions";
import connect from "react-redux/es/connect/connect";
import "react-viewer/dist/index.css";
import { roles } from "../../configs/constants";

class BestButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }

  toggleBestFlag() {
    if (this.props.media.best) {
      this.props.setFlagToMedia(this.props.media._id, false);
      photothequeApiUpsellProvider.delete(`/media/best`, {
        params: { media_id: this.props.media._id }
      });
    } else {
      this.props.setFlagToMedia(this.props.media._id, true);
      photothequeApiUpsellProvider.post(`/media/best`, {
        media_id: this.props.media._id
      });
    }
  }

  render() {
    let { media, userRoleId } = this.props;

    let iconStyle = {
      cursor: this.state.hover ? "pointer" : "default",
      fontSize: 20
    };

    return (
      <div
        onMouseEnter={() => {
          if (userRoleId !== roles.CLIENT) {
            this.setState({ hover: true });
          }
        }}
        onMouseLeave={() => {
          if (userRoleId !== roles.CLIENT) {
            this.setState({ hover: false });
          }
        }}
        onClick={() => {
          if (userRoleId !== roles.CLIENT) {
            this.toggleBestFlag();
          }
        }}
        style={{ ...iconStyle }}
      >
        <Icon type="star" theme={media.best ? "filled" : ""} />
      </div>
    );
  }
}

BestButton.propTypes = {
  media: PropTypes.object
};
const mapStateToProps = (state, ownProps) => {
  const userInfosState = state.userInfos || {};

  return {
    userRoleId: userInfosState.role_id || 5
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFlagToMedia: (media_id, isBest) => {
      dispatch(setFlagToMedia(media_id, isBest));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BestButton);



// WEBPACK FOOTER //
// src/components/phototheque/BestBtn.js